<template>
  <div v-if="testPlace" class="dashboard__actions">
    <router-link to="/">
      <i class="fas fa-arrow-left"></i> powrót
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'DashboardActions',
  computed: {
    testPlace() {
      if(this.$route.name === "home") {
        return false;
      }
      return true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
